/* @refresh reload */
import { render } from "solid-js/web";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { ChatStreamProvider } from "./chat/ChatStreamProvider";
import { ActivityProvider } from "./dashboard/ActivityProvider";
import { initSentry } from "./sentry";
import "./styles.css";

// Before render so pageload timing and early errors are captured.
initSentry();

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element #root not found in index.html");
}
render(
  () => (
    <AuthProvider>
      <ActivityProvider>
        <ChatStreamProvider>
          <App />
        </ChatStreamProvider>
      </ActivityProvider>
    </AuthProvider>
  ),
  root,
);
